// extracted by mini-css-extract-plugin
module.exports = {"bigNavButton":"BigNavButtons__bigNavButton","image":"BigNavButtons__image"};